export const KNOWN_ROLE_LABELS = Object.freeze({
  firstname: "First Name",
  middlename: "Middle Name",
  lastname: "Last Name",
  address1: "Address 1",
  address2: "Address 2",
});

export const ADDRESS_WATERMARK_BY_COUNTRY = Object.freeze({
  US: { Zip: "Zip", State: "State", County: "County", City: "City" },
  GB: { Zip: "Postal Code", State: "County", County: "District", City: "City" },
  IN: { Zip: "Zip", State: "State", County: "Taluks", City: "City" },
  KE: { Zip: "Zip", State: "Mkoa", County: "Kata", City: "City" },
  CA: { Zip: "Zip", State: "Provinces", County: "County", City: "City" },
  GR: { Zip: "Zip", State: "Peripheries", County: "Prefectures", City: "City" },
  DE: { Zip: "Zip", State: "State", County: "District", City: "City" },
  AU: { Zip: "Zip", State: "State", County: "District", City: "City" },
});

export const COUNTRY_DEPENDENT_FIELD_TYPES = Object.freeze(
  new Set(["zip", "state", "county", "city"])
);
